import { Box } from '@mui/material';

import { FHTooltip } from '../../../../../../base';
import { FORTA_BLUE } from '../../../../../../../utils/colors';
import { STATUS_ICON_MAP } from '../../constants/general';

import type { ReactNode } from 'react';

export type StatusIconVariant = 'rounded' | 'standard';

interface StatusIconProps {
  isActive: boolean;
  tooltip?: ReactNode;
  size?: number;
  variant?: StatusIconVariant;
}

const StatusIcon = ({ isActive, tooltip, size = 32, variant = 'rounded' }: StatusIconProps) => {
  const icons = STATUS_ICON_MAP[variant];
  const Icon = isActive ? icons.active : icons.inactive;
  const defaultTooltip = isActive ? 'Active' : 'Inactive';

  return (
    <FHTooltip
      placement="right-start"
      tooltipBorderRadius="8px"
      tooltipBoxShadow="0px 4px 4px 0px rgba(0, 0, 0, 0.25)"
      title={tooltip ?? defaultTooltip}
      sx={{
        '& .MuiTooltip-tooltip': {
          padding: '12px 16px',
        },
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          borderRadius: '50%',
          width: `${size + 4}px`,
          height: `${size + 4}px`,
        }}
      >
        <Icon sx={{ color: FORTA_BLUE.primary, height: `${size}px`, width: `${size}px` }} />
      </Box>
    </FHTooltip>
  );
};

export default StatusIcon;
